import { render } from "./view.vue?vue&type=template&id=e927eb44&scoped=true"
const script = {}

import "./view.vue?vue&type=style&index=0&id=e927eb44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e927eb44"]])

export default __exports__